export default "__VITE_ASSET__DEKdS72$__"